'use strict';

function dateIsEqual(a, b) {
  if(a instanceof Date && b instanceof Date) {
    return a.getTime() === b.getTime();
  }

  return false;
}

function EmailToTaskNewCtrl(
  $scope,
  $stateParams,
  $state,
  EmailToTaskService,
  CompanySettingUnitsService,
  CompanyTaskService,
  growl,
  $translate) {
  
  function checkDueAt() {
    if($scope.emailToTask.dueAt < $scope.emailToTask.startAt) {
      $scope.emailToTask.dueAt = new Date($scope.emailToTask.startAt.getTime());
      $scope.emailToTask.dueAt.setHours($scope.emailToTask.dueAt.getHours() + 1);
    }
  }

  var nextDate = new Date();
      nextDate.setHours(nextDate.getHours() + 1);

  var DEFAULT_EMAIL_TO_TASK = {
    startAt:    new Date(),
    dueAt:      nextDate,
    assignees:  [],
    public:     true,
    wholeDay:   false,
    saveOnlyFile: false,
    importance: 'NORMAL',
    type: 'REMINDER',
    createdBy: $scope.currentUser,
    publication: null,
    connectedCustomer: null,
    reminderDates: [],
    days: 0
  };

  DEFAULT_EMAIL_TO_TASK.assignees.push({
    id:    $scope.currentUser.id,
    name:  $scope.currentUser.name,
    email: $scope.currentUser.email
  });

  $scope.emailToTask = new EmailToTaskService(angular.copy(DEFAULT_EMAIL_TO_TASK));

  CompanyTaskService.queryCategories({companyId: $stateParams.companyId, all: true}).$promise.then(function(categories){
    $scope.categories = categories;
  });

  $scope.$watch("[emailToTask.dueAt, emailToTask.startAt]", function(newValue, oldValue) {
    if(newValue[0] && oldValue[0] && !dateIsEqual(newValue[0], oldValue[0]) ||
       newValue[1] && oldValue[1] && !dateIsEqual(newValue[1], oldValue[1])) {
      checkDueAt();
    }
  }, true);

  $scope.saveTask = function() {
    $scope.emailToTask.$save({companyId: $stateParams.companyId}, function(){
      growl.addSuccessMessage($translate.instant('email-to-task.save-success'));
      $state.go("root.company.account.email-to-task.list");
    }, function(){
      growl.addErrorMessage($translate.instant('email-to-task.save-failure'));
    });
  };

  $scope.addAssignee = function(assignee) {
    $scope.emailToTask.assignees.push(assignee);
    angular.element('#filterAssignees').val('');
  };

  $scope.addedAssignees = function(assignee) {
    return ($scope.emailToTask.assignees.indexOf(assignee) === -1);
  };

  $scope.removeAssignee = function(assignee) {
    $scope.emailToTask.assignees.splice($scope.emailToTask.assignees.indexOf(assignee), 1);
  };

  $scope.searchUnits = function(filter) {
    CompanySettingUnitsService.query({companyId: $scope.companyId, limit: 10, q: filter}).$promise.then(function(units) {
      return units.filter(function(item) {
        return !$scope.emailToTask.unit || ($scope.emailToTask.unit && item.id !== $scope.emailToTask.unit.id);
      });
    }).then(function(nonUnits) {
      $scope.units = nonUnits;
    });
  };
}

angular.module('dokiv')
  .controller('EmailToTaskNewCtrl', [
    '$scope',
    '$stateParams',
    '$state',
    'EmailToTaskService',
    'CompanySettingUnitsService',
    'CompanyTaskService',
    'growl',
    '$translate',
    EmailToTaskNewCtrl]);


//////////////////
// WEBPACK FOOTER
// ./scripts/company/email-to-task/EmailToTaskNewCtrl.js
// module id = 349
// module chunks = 0